"use client"
import { signIn, useSession } from "next-auth/react";
import { useRouter } from "next/navigation";
import {Typography, Button, Stack} from "@mui/material";
import {useEffect, useState} from "react";
import {getProviders} from "../../../../api/AuthAPI";



export default function Login() {
    const [providers, setProviders] = useState<{id: string, name: string}[]>([]);

    const router = useRouter();
    const { status } = useSession();

    useEffect(() => {
        if(providers.length === 1) {
            handleProvider(providers[0].id)
        }
    }, [providers]);

    useEffect(() => {
        if (status === "unauthenticated") {
            getProviders().then(value => {
                setProviders(value);
            })
        } else if (status === "authenticated") {
            void router.push("/legal");
        }
    }, [status]);

    const handleProvider = (id: any | string) => {
        return signIn(id, {redirectTo: "/legal"});
    };

    return <Stack
        sx={{ padding: 4 }}
        gap={2}
        alignItems="center"
    >
        {providers.map( (provider) => (
            <Button sx={{width: '400px'}} key={provider.id} onClick={event => handleProvider(provider.id)} variant="contained" color="secondary">
                <Typography variant="body1">{provider.name}</Typography>
            </Button>
        ))}
    </Stack>;
}